import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search, Loader2 } from "lucide-react";
import { api, regCode, EDITION_STYLE } from "../lib/api";

export default function Explore() {
  const [records, setRecords] = useState(null);
  const [q, setQ] = useState("");
  const [type, setType] = useState("");

  const load = () => {
    setRecords(null);
    api.get("/registries/public", { params: { q: q || undefined, registry_type: type || undefined } })
      .then(({ data }) => setRecords(data)).catch(() => setRecords([]));
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [type]);

  return (
    <div className="max-w-7xl mx-auto px-5 lg:px-10 py-24" data-testid="explore-page">
      <div className="hy-label">Public Registry</div>
      <h1 className="font-display text-4xl sm:text-5xl text-white mt-5">The HYLUNER registry wall</h1>
      <p className="text-sm text-slate-400 mt-6 max-w-2xl leading-relaxed">
        Every confirmed record is published here in registry order — verifiable by anyone, forever.
      </p>

      <div className="flex flex-col sm:flex-row gap-3 mt-10">
        <form onSubmit={(e) => { e.preventDefault(); load(); }} className="flex gap-3 flex-1">
          <input value={q} onChange={(e) => setQ(e.target.value)} className="hy-input" placeholder="Search dedication or registry ID" data-testid="explore-search-input" />
          <button className="hy-btn px-7 text-xs uppercase flex items-center gap-2" data-testid="explore-search-btn"><Search className="w-4 h-4" /></button>
        </form>
        <div className="flex gap-2">
          {[["", "All"], ["STAR", "Stars"], ["MOON", "Moon"]].map(([v, l]) => (
            <button key={l} onClick={() => setType(v)} data-testid={`explore-filter-${l.toLowerCase()}`}
              className={`px-5 py-3 text-xs uppercase tracking-widest border transition-colors ${type === v ? "border-amber-400 text-amber-200 bg-amber-500/10" : "border-amber-500/20 text-slate-400"}`}>
              {l}
            </button>
          ))}
        </div>
      </div>

      {records === null ? (
        <Loader2 className="w-6 h-6 animate-spin text-amber-300 mt-16" />
      ) : records.length === 0 ? (
        <p className="font-serif-accent italic text-slate-400 text-lg mt-16" data-testid="explore-empty">
          No confirmed registry records yet. The first entry is still available.
        </p>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-14" data-testid="explore-grid">
          {records.map((r) => (
            <Link key={r.registry_id} to={`/registry/${r.registry_id}`} className="hy-card p-7 block" data-testid={`explore-card-${r.registry_id}`}>
              <div className="flex items-center justify-between">
                <span className={`text-[0.55rem] uppercase tracking-[0.2em] px-3 py-1 border rounded-full ${EDITION_STYLE[r.edition]}`}>{r.edition}</span>
                <span className="hy-label text-[0.55rem]">{r.registry_type}</span>
              </div>
              <div className="font-display text-lg text-amber-200 mt-5">{regCode(r.registry_number)}</div>
              <div className="text-white text-sm mt-3">{r.dedication_name}</div>
              <div className="font-mono-hy text-[0.7rem] text-slate-500 mt-2">{r.location_display}</div>
              {r.occasion && <div className="text-xs text-slate-500 mt-3">{r.occasion}</div>}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
